import logoImage from '../../../images/logo.svg';

const CompanyLogo = () => {
  return (
    <div className="flex items-center mr-8">
      <div 
        className="h-[50px] w-[80px] bg-cover bg-center"
        style={{ backgroundImage: `url(${logoImage})` }}
      ></div>
    </div>
  );
};

export default CompanyLogo;
